export default __webpack_public_path__ + "static/media/Union.17d98b60.svg";